import { LayerType, LayerTypeValue } from "@/model/DataModel.ts"

// this *variable* will be replaced during the build by the github actions workflow
export const appVersion = "dc66cc58.1791902133"

export enum Feature {
	Transactions = "transactions",
	CityProspection = "cityProspection",
	AddOpportunity = "addOpportunity",
	AddOpportunityFull = "addOpportunityFull",
	SelectProjectsFromHubSpot = "selectProjectsFromHubSpot",
	ProjectAccessControl = "projectAccessControl",
	DevTypes = "devTypes",
	/** @lintignore */
	ModeTable = "mode.table",
	TransferOpportunityTarget = "transferOpportunityTarget",
	MyWorkspace = "myWorkspace",
	/** @lintignore */
	TransactionsTable = "transactionsTable",
	/** @lintignore */
	OpportunityStage = "opportunityStage",
	/** @lintignore */
	ParcelPdfV2 = "parcelPdfV2",
	ParcelPdfV2Maps = "parcelPdfV2Maps",
	/** @lintignore */
	ExtendedAccess = "extendedAccess",
	/** @lintignore */
	AppTour = "appTour",
	/** @lintignore */
	Assistant = "assistant",
}

export class UI {
	private readonly features: string[]

	constructor(features: string[] = []) {
		this.features = features
	}

	has(feature: string): boolean {
		return this.features.includes(feature)
	}
}

export const config = {
	filters: [LayerType.ListingLanderz] as readonly LayerTypeValue[],

	ui: new UI([
		Feature.Transactions,
		Feature.AddOpportunity,
		Feature.CityProspection,
		Feature.SelectProjectsFromHubSpot,
		Feature.ProjectAccessControl,
		Feature.DevTypes,
		Feature.TransferOpportunityTarget,
		Feature.ModeTable,
		Feature.MyWorkspace,
		Feature.OpportunityStage,
		Feature.ParcelPdfV2,
		// Feature.ParcelPdfV2Maps,
		// Feature.TransactionsTable,
		// Feature.ExtendedAccess,
		// Feature.AppTour,
		Feature.Assistant,
	]),
}
